export const ICONS = {
    iconPath : 'assets/icons',
    icons: [
        {
            name: 'stla-chrysler',
            fileName: 'chrysler',
        },
        {
            name: 'stla-eye',
            fileName: '0899_Eye',
        },
        {
            name: 'stla-search',
            fileName: 'search',
        },
        {
            name: 'stla-info',
            fileName: '0492_PoiTouristInformation'
        },
        {
            name: 'stla-earth',
            fileName: '0605_Earth'
        },
        {
            name: 'stla-chevron-down-large',
            fileName: 'chevronDownLarge'
        },
        {
            name: 'stla-close',
            fileName: 'close'
        },
        {
            name: 'stla-hamburger-menu',
            fileName: 'BurgerMenu'
        },
        // {
        //     name: 'stla-ringtone',
        //     fileName: 'ringtone'
        // },
        // {
        //     name: 'stla-profile',
        //     fileName: 'profile'
        // },
        {
            name: 'stla-profile-new',
            fileName: 'profile-new'
        },
        {
            name: 'stla-chevron-left-large',
            fileName: 'chevronLeftLarge'
        },
        {
            name: 'stla-chevron-right-large',
            fileName: 'chevronRightLarge'
        },
        {
            name: 'stla-edit',
            fileName: 'edit'
        },
        {
            name: 'stla-play',
            fileName: 'play'
        },
        {
            name: 'stla-pause',
            fileName: 'pause'
        },
        {
            name: 'stla-home',
            fileName: 'home'
        },
        {
            name: 'stla-logoStellantis',
            fileName: 'logoStellantis'
        },
        {
            name: 'stla-externalLink',
            fileName: 'ExternalLink'
        },
        {
            name: 'stla-chatBot',
            fileName: 'chat_bot'
        },
        {
            name: 'stla-language-new',
            fileName: 'LanguageSwitcher-new'
        },
        {
            name: 'stla-dropdown',
            fileName: 'dropdown'
        },
        {
            name: 'stla-ringtone-new',
            fileName: 'ringtone-new'
        }
    ]
}
